/* eslint-disable @typescript-eslint/naming-convention */
import {
  AuditAdminPermission,
  BasePermission,
  ConfigurationAdminPermission,
  DocumentSuperAdminPermission,
  ImpersonateExternalUserPermission,
  ImpersonateInternalUserPermission,
  NewSiteSubmissionPermission,
  NotificationAdminPermission,
  OrganizationPeoplePermission,
  OrganizationPermission,
  PeopleAdminPermission,
  PermissionGrants,
  QuestionnaireAdminPermission,
  RoleAdminPermission,
  SiteCorrespondencePermission,
  SiteDetailPermission,
  SiteStudyDetailPermission,
  SiteSubmissionPermission,
  SiteTeamPermission,
  StudyCorrespondencePermission,
  StudyDetailPermission,
  StudySubmissionPermission,
  StudyTeamPermission,
  SubmissionSuperAdminPermission,
  AppealSubmissionPermission,
  CancelSubmissionPermission,
  ViewOrganizationPermission,
  ViewOrganizationDetailPermission,
  AddOrganizationAdminUserPermission,
  RemoveOrganizationAdminUserPermission,
  ViewOrganizationAdminUserPermission,
  ViewOrganizationStudiesPermission,
  ViewOrganizationSitesPermission,
  SubmissionCorrespondencePermission,
} from '../interfaces/permissions.interface';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Permission } from '@team-management/models/roles';

export function loadGeneralPermissionGrants() {
  return {
    NewSiteSubmission: new NewSiteSubmissionPermission(),
    SiteCorrespondence: new SiteCorrespondencePermission(),
    SubmissionCorrespondence: new SubmissionCorrespondencePermission(),
    SiteStudyDetail: new SiteStudyDetailPermission(),
    SiteSubmission: new SiteSubmissionPermission(),
    SiteTeam: new SiteTeamPermission(),
    StudyCorrespondence: new StudyCorrespondencePermission(),
    StudyDetail: new StudyDetailPermission(),
    StudySubmission: new StudySubmissionPermission(),
    StudyTeam: new StudyTeamPermission(),
    siteDetail: new SiteDetailPermission(),
    ViewOrganization: new ViewOrganizationPermission(),
    ViewOrganizationDetail: new ViewOrganizationDetailPermission(),
    AddOrganizationAdminUser: new AddOrganizationAdminUserPermission(),
    RemoveOrganizationAdminUser: new RemoveOrganizationAdminUserPermission(),
    ViewOrganizationAdminUser: new ViewOrganizationAdminUserPermission(),
    ViewOrganizationStudies: new ViewOrganizationStudiesPermission(),
    ViewOrganizationSites: new ViewOrganizationSitesPermission(),
  };
}

//INTERNAL PERMISSIONS
export function loadInternalPermissionGrants() {
  return {
    auditAdmin: new AuditAdminPermission(),
    configurationAdmin: new ConfigurationAdminPermission(),
    documentSuperAdmin: new DocumentSuperAdminPermission(),
    impersonateExternalUser: new ImpersonateExternalUserPermission(),
    impersonateInternalUser: new ImpersonateInternalUserPermission(),
    notificationAdmin: new NotificationAdminPermission(),
    organizationPeoplePermission: new OrganizationPeoplePermission(),
    organizationPermission: new OrganizationPermission(),
    peopleAdmin: new PeopleAdminPermission(),
    questionnaireAdmin: new QuestionnaireAdminPermission(),
    roleAdmin: new RoleAdminPermission(),
    submissionSuperAdminPermission: new SubmissionSuperAdminPermission(),
    AppealSubmissionPermission: new AppealSubmissionPermission(),
    CancelSubmissionPermission: new CancelSubmissionPermission(),
  };
}

export function checkPermissions(
  rolePermissions: Permission[],
  permissions: BasePermission[],
  grants: PermissionGrants[],
) {
  return grants.every((userGrant) =>
    permissions.some((permission) =>
      rolePermissions.some(
        (rolePermission) =>
          rolePermission.name === permission.name &&
          coerceBooleanProperty(rolePermission[userGrant as keyof Permission]),
      ),
    ),
  );
}
